import { OverviewWidgetResponse_Field, OverviewWidgetResponse_FieldGroup } from '../proto/generated/overview-widget'

/** Strip parameter suffix (`shareholding_promoter_holding|Current` → base code). */
export const baseFieldCode = (code: string | undefined): string => code?.split('|')[0] ?? ''

export const indexFieldsByBaseCode = (
    fields: OverviewWidgetResponse_Field[]
): Map<string, OverviewWidgetResponse_Field> => {
    const map = new Map<string, OverviewWidgetResponse_Field>()
    fields.forEach((field) => {
        const code = baseFieldCode(field.screenerField?.code)
        if (code && !map.has(code)) map.set(code, field)
    })
    return map
}

export const findFieldByBaseCode = (
    fieldGroups: OverviewWidgetResponse_FieldGroup[] | undefined,
    code: string
): OverviewWidgetResponse_Field | undefined =>
    fieldGroups?.flatMap((group) => group.fields).find((field) => baseFieldCode(field.screenerField?.code) === code)
